// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Audit log — link to UserConsents from dashboard */
.audit-snapshot-card {
    display: block;
    margin-bottom: 20px;
    text-decoration: none;
    color: inherit;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(24, 22, 18, 0.75);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.16);
    transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
}

.audit-snapshot-card:hover {
    border-color: rgba(192, 159, 83, 0.4);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.22);
    transform: translateY(-1px);
}

.audit-snapshot-card:focus-visible {
    outline: 2px solid rgba(192, 159, 83, 0.85);
    outline-offset: 3px;
}

/* System health — glanceable top accent */
.audit-snapshot-card--health-healthy {
    border-top: 3px solid rgba(100, 190, 125, 0.95);
}

.audit-snapshot-card--health-degraded {
    border-top: 3px solid rgba(220, 165, 75, 0.95);
}

.audit-snapshot-card--health-error {
    border-top: 3px solid rgba(230, 95, 95, 0.95);
}

.audit-snapshot-card--health-loading {
    border-top: 3px solid rgba(130, 165, 210, 0.9);
}

.audit-snapshot-card__body {
    padding: 18px 22px 20px;
}

.audit-snapshot-card__text {
    min-width: 0;
}

.audit-snapshot-card__title-row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px 16px;
    margin-bottom: 6px;
}

.audit-snapshot-card__title {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: #e8e8e8;
    flex: 1;
    min-width: 9rem;
}

.audit-snapshot-card__health-sub {
    margin: 0 0 16px;
    font-size: 0.78rem;
    line-height: 1.4;
    color: #949494;
    max-width: 48rem;
}

.audit-snapshot-card__health-pill {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    border-radius: 999px;
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    flex-shrink: 0;
    max-width: min(100%, 17rem);
    border: 1px solid transparent;
}

.audit-snapshot-card__health-label {
    line-height: 1.25;
    text-align: left;
}

.audit-snapshot-card__health-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
}

.audit-snapshot-card__health-pill--healthy {
    background: rgba(80, 150, 100, 0.25);
    border-color: rgba(120, 200, 145, 0.5);
    color: #b5e8c8;
}

.audit-snapshot-card__health-pill--healthy .audit-snapshot-card__health-dot {
    background: #6fd88a;
    box-shadow: 0 0 10px rgba(111, 216, 138, 0.55);
}

.audit-snapshot-card__health-pill--degraded {
    background: rgba(200, 140, 60, 0.22);
    border-color: rgba(230, 175, 80, 0.45);
    color: #f0d9a8;
}

.audit-snapshot-card__health-pill--degraded .audit-snapshot-card__health-dot {
    background: #e8b04a;
    box-shadow: 0 0 8px rgba(232, 176, 74, 0.45);
}

.audit-snapshot-card__health-pill--error {
    background: rgba(200, 70, 70, 0.22);
    border-color: rgba(235, 110, 110, 0.5);
    color: #f0b0b0;
}

.audit-snapshot-card__health-pill--error .audit-snapshot-card__health-dot {
    background: #e85c5c;
    box-shadow: 0 0 8px rgba(232, 92, 92, 0.55);
}

.audit-snapshot-card__health-pill--loading {
    background: rgba(90, 120, 170, 0.22);
    border-color: rgba(140, 170, 220, 0.45);
    color: #c5d8f0;
}

.audit-snapshot-card__health-pill--loading .audit-snapshot-card__health-dot {
    background: #8cb4e8;
    animation: audit-snapshot-health-pulse 1.1s ease-in-out infinite;
}

@keyframes audit-snapshot-health-pulse {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: 0.35;
    }
}

.audit-snapshot-card__hint {
    margin: 0;
    font-size: 0.8rem;
    color: #888;
}

.audit-snapshot-card__stats {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
    margin: 16px 0 0;
    padding: 14px 18px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.05);
}

.audit-snapshot-card__stat {
    margin: 0;
    padding: 0 20px 0 0;
    border-right: 1px solid rgba(255, 255, 255, 0.06);
    margin-right: 20px;
}

.audit-snapshot-card__stat:last-child {
    border-right: none;
    padding-right: 0;
    margin-right: 0;
}

.audit-snapshot-card__stat dt {
    margin: 0 0 3px;
    font-size: 0.67rem;
    font-weight: 600;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.3);
}

.audit-snapshot-card__stat dd {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 600;
    color: #c0a053;
    font-variant-numeric: tabular-nums;
}

.audit-snapshot-card__cta-wrap {
    margin-top: 18px;
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.audit-snapshot-card__cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.85rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #c0a053;
    padding: 10px 16px;
    border-radius: 8px;
    border: 1px solid rgba(192, 159, 83, 0.35);
    background: rgba(192, 159, 83, 0.08);
}

.audit-snapshot-card:hover .audit-snapshot-card__cta {
    background: rgba(192, 159, 83, 0.14);
    border-color: rgba(192, 159, 83, 0.55);
}

.audit-snapshot-card__meta-lines {
    margin: 0 0 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.audit-snapshot-card__meta-line {
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 8px 12px;
    font-size: 0.85rem;
    line-height: 1.4;
}

.audit-snapshot-card__meta-label {
    font-weight: 600;
    color: #b8b8b8;
    min-width: 10rem;
}

.audit-snapshot-card__meta-value {
    color: #e4e4e4;
}

.audit-snapshot-card__meta-suffix {
    font-size: 0.72rem;
    font-weight: 500;
    letter-spacing: 0.04em;
    color: #777;
    text-transform: uppercase;
}

.audit-snapshot-card__feed {
    list-style: none;
    margin: 0 0 16px;
    padding: 12px 14px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.22);
    border: 1px solid rgba(255, 255, 255, 0.06);
}

.audit-snapshot-card__feed--demo {
    border-style: dashed;
    border-color: rgba(192, 159, 83, 0.25);
}

.audit-snapshot-card__feed-note {
    margin: 0 0 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #888;
}

.audit-snapshot-card__feed-row {
    margin: 0;
    padding: 6px 0;
    font-size: 0.8125rem;
    color: #c8c8c8;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 4px 6px;
}

.audit-snapshot-card__feed-row + .audit-snapshot-card__feed-row {
    border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.audit-snapshot-card__feed-row--interactive {
    cursor: pointer;
    border-radius: 6px;
    margin: 0 -6px;
    padding: 6px;
    transition:
        background 0.15s ease,
        box-shadow 0.15s ease;
}

.audit-snapshot-card__feed-row--interactive:hover {
    background: rgba(192, 159, 83, 0.08);
}

.audit-snapshot-card__feed-row--interactive:focus-visible {
    outline: 2px solid rgba(192, 159, 83, 0.75);
    outline-offset: 2px;
}

.audit-snapshot-card__feed-row--map-selected {
    background: rgba(192, 159, 83, 0.12);
    box-shadow: inset 3px 0 0 rgba(192, 159, 83, 0.85);
}

.audit-snapshot-card__feed-country {
    font-weight: 700;
    color: #c0a053;
    min-width: 1.75rem;
}

.audit-snapshot-card__feed-fw {
    color: #9ec5e8;
}

.audit-snapshot-card__feed-summary {
    color: #dcdcdc;
}

.audit-snapshot-card__feed-time {
    margin-left: auto;
    font-variant-numeric: tabular-nums;
    color: #999;
}

.audit-snapshot-card__feed-sep {
    color: #555;
    user-select: none;
}

.audit-snapshot-card__feed-map-row {
    display: grid;
    align-items: stretch;
    gap: 16px 20px;
    margin: 14px 0 16px;
}

@media (max-width: 720px) {
    .audit-snapshot-card__feed-map-row {
        grid-template-columns: 1fr;
    }
}

.audit-snapshot-card__feed-col {
    min-width: 0;
}

.audit-snapshot-card__map-col {
    min-width: 0;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.audit-snapshot-card__map-col > .audit-compliance-map {
    flex: 1 1 auto;
    min-height: 0;
}

.audit-snapshot-card__feed-col .audit-snapshot-card__feed {
    margin-bottom: 0;
}

.audit-snapshot-card__feed-col .audit-snapshot-card__hint {
    margin: 0;
    padding: 12px 14px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.06);
}
`, "",{"version":3,"sources":["webpack://./src/Components/AuditSnapshotCard/AuditSnapshotCard.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,mBAAmB;IACnB,2CAA2C;IAC3C,kCAAkC;IAClC,0CAA0C;IAC1C,8EAA8E;AAClF;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA,0CAA0C;AAC1C;IACI,+CAA+C;AACnD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,OAAO;IACP,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,mCAAmC;IACnC,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;IACpC,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gEAAgE;AACpE;;AAEA;IACI;;QAEI,UAAU;IACd;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;IAC9B,2CAA2C;AAC/C;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,iDAAiD;IACjD,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,2CAA2C;AAC/C;;AAEA;IACI,oBAAoB;IACpB,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,cAAc;IACd,oBAAoB;IACpB,cAAc;IACd,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ;;6BAEyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,2CAA2C;AAC/C","sourcesContent":["/* Audit log — link to UserConsents from dashboard */\n.audit-snapshot-card {\n    display: block;\n    margin-bottom: 20px;\n    text-decoration: none;\n    color: inherit;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(24, 22, 18, 0.75);\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.16);\n    transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;\n}\n\n.audit-snapshot-card:hover {\n    border-color: rgba(192, 159, 83, 0.4);\n    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.22);\n    transform: translateY(-1px);\n}\n\n.audit-snapshot-card:focus-visible {\n    outline: 2px solid rgba(192, 159, 83, 0.85);\n    outline-offset: 3px;\n}\n\n/* System health — glanceable top accent */\n.audit-snapshot-card--health-healthy {\n    border-top: 3px solid rgba(100, 190, 125, 0.95);\n}\n\n.audit-snapshot-card--health-degraded {\n    border-top: 3px solid rgba(220, 165, 75, 0.95);\n}\n\n.audit-snapshot-card--health-error {\n    border-top: 3px solid rgba(230, 95, 95, 0.95);\n}\n\n.audit-snapshot-card--health-loading {\n    border-top: 3px solid rgba(130, 165, 210, 0.9);\n}\n\n.audit-snapshot-card__body {\n    padding: 18px 22px 20px;\n}\n\n.audit-snapshot-card__text {\n    min-width: 0;\n}\n\n.audit-snapshot-card__title-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px 16px;\n    margin-bottom: 6px;\n}\n\n.audit-snapshot-card__title {\n    margin: 0;\n    font-size: 1.1rem;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    color: #e8e8e8;\n    flex: 1;\n    min-width: 9rem;\n}\n\n.audit-snapshot-card__health-sub {\n    margin: 0 0 16px;\n    font-size: 0.78rem;\n    line-height: 1.4;\n    color: #949494;\n    max-width: 48rem;\n}\n\n.audit-snapshot-card__health-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 12px;\n    border-radius: 999px;\n    font-size: 0.68rem;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    flex-shrink: 0;\n    max-width: min(100%, 17rem);\n    border: 1px solid transparent;\n}\n\n.audit-snapshot-card__health-label {\n    line-height: 1.25;\n    text-align: left;\n}\n\n.audit-snapshot-card__health-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.audit-snapshot-card__health-pill--healthy {\n    background: rgba(80, 150, 100, 0.25);\n    border-color: rgba(120, 200, 145, 0.5);\n    color: #b5e8c8;\n}\n\n.audit-snapshot-card__health-pill--healthy .audit-snapshot-card__health-dot {\n    background: #6fd88a;\n    box-shadow: 0 0 10px rgba(111, 216, 138, 0.55);\n}\n\n.audit-snapshot-card__health-pill--degraded {\n    background: rgba(200, 140, 60, 0.22);\n    border-color: rgba(230, 175, 80, 0.45);\n    color: #f0d9a8;\n}\n\n.audit-snapshot-card__health-pill--degraded .audit-snapshot-card__health-dot {\n    background: #e8b04a;\n    box-shadow: 0 0 8px rgba(232, 176, 74, 0.45);\n}\n\n.audit-snapshot-card__health-pill--error {\n    background: rgba(200, 70, 70, 0.22);\n    border-color: rgba(235, 110, 110, 0.5);\n    color: #f0b0b0;\n}\n\n.audit-snapshot-card__health-pill--error .audit-snapshot-card__health-dot {\n    background: #e85c5c;\n    box-shadow: 0 0 8px rgba(232, 92, 92, 0.55);\n}\n\n.audit-snapshot-card__health-pill--loading {\n    background: rgba(90, 120, 170, 0.22);\n    border-color: rgba(140, 170, 220, 0.45);\n    color: #c5d8f0;\n}\n\n.audit-snapshot-card__health-pill--loading .audit-snapshot-card__health-dot {\n    background: #8cb4e8;\n    animation: audit-snapshot-health-pulse 1.1s ease-in-out infinite;\n}\n\n@keyframes audit-snapshot-health-pulse {\n    0%,\n    100% {\n        opacity: 1;\n    }\n    50% {\n        opacity: 0.35;\n    }\n}\n\n.audit-snapshot-card__hint {\n    margin: 0;\n    font-size: 0.8rem;\n    color: #888;\n}\n\n.audit-snapshot-card__stats {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0;\n    margin: 16px 0 0;\n    padding: 14px 18px;\n    border-radius: 8px;\n    background: rgba(0, 0, 0, 0.2);\n    border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.audit-snapshot-card__stat {\n    margin: 0;\n    padding: 0 20px 0 0;\n    border-right: 1px solid rgba(255, 255, 255, 0.06);\n    margin-right: 20px;\n}\n\n.audit-snapshot-card__stat:last-child {\n    border-right: none;\n    padding-right: 0;\n    margin-right: 0;\n}\n\n.audit-snapshot-card__stat dt {\n    margin: 0 0 3px;\n    font-size: 0.67rem;\n    font-weight: 600;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.3);\n}\n\n.audit-snapshot-card__stat dd {\n    margin: 0;\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: #c0a053;\n    font-variant-numeric: tabular-nums;\n}\n\n.audit-snapshot-card__cta-wrap {\n    margin-top: 18px;\n    padding-top: 16px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.audit-snapshot-card__cta {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.85rem;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #c0a053;\n    padding: 10px 16px;\n    border-radius: 8px;\n    border: 1px solid rgba(192, 159, 83, 0.35);\n    background: rgba(192, 159, 83, 0.08);\n}\n\n.audit-snapshot-card:hover .audit-snapshot-card__cta {\n    background: rgba(192, 159, 83, 0.14);\n    border-color: rgba(192, 159, 83, 0.55);\n}\n\n.audit-snapshot-card__meta-lines {\n    margin: 0 0 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.audit-snapshot-card__meta-line {\n    margin: 0;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 8px 12px;\n    font-size: 0.85rem;\n    line-height: 1.4;\n}\n\n.audit-snapshot-card__meta-label {\n    font-weight: 600;\n    color: #b8b8b8;\n    min-width: 10rem;\n}\n\n.audit-snapshot-card__meta-value {\n    color: #e4e4e4;\n}\n\n.audit-snapshot-card__meta-suffix {\n    font-size: 0.72rem;\n    font-weight: 500;\n    letter-spacing: 0.04em;\n    color: #777;\n    text-transform: uppercase;\n}\n\n.audit-snapshot-card__feed {\n    list-style: none;\n    margin: 0 0 16px;\n    padding: 12px 14px;\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.22);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.audit-snapshot-card__feed--demo {\n    border-style: dashed;\n    border-color: rgba(192, 159, 83, 0.25);\n}\n\n.audit-snapshot-card__feed-note {\n    margin: 0 0 10px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n    font-size: 0.68rem;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: #888;\n}\n\n.audit-snapshot-card__feed-row {\n    margin: 0;\n    padding: 6px 0;\n    font-size: 0.8125rem;\n    color: #c8c8c8;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 4px 6px;\n}\n\n.audit-snapshot-card__feed-row + .audit-snapshot-card__feed-row {\n    border-top: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.audit-snapshot-card__feed-row--interactive {\n    cursor: pointer;\n    border-radius: 6px;\n    margin: 0 -6px;\n    padding: 6px;\n    transition:\n        background 0.15s ease,\n        box-shadow 0.15s ease;\n}\n\n.audit-snapshot-card__feed-row--interactive:hover {\n    background: rgba(192, 159, 83, 0.08);\n}\n\n.audit-snapshot-card__feed-row--interactive:focus-visible {\n    outline: 2px solid rgba(192, 159, 83, 0.75);\n    outline-offset: 2px;\n}\n\n.audit-snapshot-card__feed-row--map-selected {\n    background: rgba(192, 159, 83, 0.12);\n    box-shadow: inset 3px 0 0 rgba(192, 159, 83, 0.85);\n}\n\n.audit-snapshot-card__feed-country {\n    font-weight: 700;\n    color: #c0a053;\n    min-width: 1.75rem;\n}\n\n.audit-snapshot-card__feed-fw {\n    color: #9ec5e8;\n}\n\n.audit-snapshot-card__feed-summary {\n    color: #dcdcdc;\n}\n\n.audit-snapshot-card__feed-time {\n    margin-left: auto;\n    font-variant-numeric: tabular-nums;\n    color: #999;\n}\n\n.audit-snapshot-card__feed-sep {\n    color: #555;\n    user-select: none;\n}\n\n.audit-snapshot-card__feed-map-row {\n    display: grid;\n    align-items: stretch;\n    gap: 16px 20px;\n    margin: 14px 0 16px;\n}\n\n@media (max-width: 720px) {\n    .audit-snapshot-card__feed-map-row {\n        grid-template-columns: 1fr;\n    }\n}\n\n.audit-snapshot-card__feed-col {\n    min-width: 0;\n}\n\n.audit-snapshot-card__map-col {\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n}\n\n.audit-snapshot-card__map-col > .audit-compliance-map {\n    flex: 1 1 auto;\n    min-height: 0;\n}\n\n.audit-snapshot-card__feed-col .audit-snapshot-card__feed {\n    margin-bottom: 0;\n}\n\n.audit-snapshot-card__feed-col .audit-snapshot-card__hint {\n    margin: 0;\n    padding: 12px 14px;\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.18);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
